export default {"src":"/_next/static/media/safe.0e43c87d.svg","height":30,"width":30};